export default "__VITE_ASSET__BvBaOprq__"